<template>
    <div class="d-md-flex mb-3">
        <div class="col-md-6 col-sm-12 col-xs-12 p-0">
            <Valoracion :base_id="base.id" :valoracion="base.valoracion" @getBase="$emit('getBase')"/>
        </div>
        <div class=" col-md-6 col-sm-12 col-xs-12 p-0">

        </div>
    </div>
</template>

<script>
    import Valoracion from '@/components/backend/bases/components/valoraciones/Valoracion.vue';

    export default {

        props: ['base'],

        components: {
            Valoracion
        }

    }
</script>